import { render, staticRenderFns } from "./WipSAPForm.vue?vue&type=template&id=232244ca&scoped=true&"
import script from "./WipSAPForm.vue?vue&type=script&lang=ts&"
export * from "./WipSAPForm.vue?vue&type=script&lang=ts&"
import style0 from "./WipSAPForm.vue?vue&type=style&index=0&id=232244ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232244ca",
  null
  
)

export default component.exports